(function () {
  var ROOT = '[data-ctr-pcos-relief-timeline]';

  function ensureSwiper() {
    if (customElements.get('swiper-container')) {
      return Promise.resolve();
    }

    if (!document.querySelector('script[src*="swiper-element-bundle"]')) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js';
      document.head.appendChild(script);
    }

    return customElements.whenDefined('swiper-container');
  }

  function initSection(root) {
    if (!root || root.dataset.ctrInit === 'true') return;

    var swiperEl = root.querySelector('[data-ctr-swiper]');
    if (!swiperEl || !swiperEl.querySelector('swiper-slide')) {
      root.dataset.ctrInit = 'true';
      return;
    }

    var prevButtons = root.querySelectorAll('[data-ctr-prev]');
    var nextButtons = root.querySelectorAll('[data-ctr-next]');
    var markers = root.querySelectorAll('[data-ctr-marker]');
    var dots = root.querySelectorAll('[data-ctr-dot]');
    var slides = root.querySelectorAll('swiper-slide');
    var selectedIndex = 0;
    var lockSelected = false;
    var unlockTimer = null;

    function onPrev() {
      lockSelected = false;
      if (swiperEl.swiper) swiperEl.swiper.slidePrev();
    }

    function onNext() {
      lockSelected = false;
      if (swiperEl.swiper) swiperEl.swiper.slideNext();
    }

    function setActive(index) {
      selectedIndex = index;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      markers.forEach(function (marker, i) {
        var active = i === index;
        marker.classList.toggle('is-active', active);
        if (active) {
          marker.setAttribute('aria-current', 'true');
        } else {
          marker.removeAttribute('aria-current');
        }
      });

      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function activateSlide(index) {
      if (isNaN(index) || index < 0 || index >= slides.length) return;

      lockSelected = true;
      setActive(index);

      if (unlockTimer) clearTimeout(unlockTimer);
      unlockTimer = setTimeout(function () {
        lockSelected = false;
      }, 400);

      if (swiperEl.swiper) swiperEl.swiper.slideTo(index);
    }

    function onJump(event) {
      event.preventDefault();
      event.stopPropagation();
      var index = parseInt(event.currentTarget.getAttribute('data-index'), 10);
      activateSlide(index);
    }

    function onSlideClick(event) {
      if (swiperEl.swiper && swiperEl.swiper.allowClick === false) return;
      var slide = event.currentTarget;
      var index = Array.prototype.indexOf.call(slides, slide);
      activateSlide(index);
    }

    function updateArrows(swiper) {
      prevButtons.forEach(function (button) {
        button.disabled = swiper.isBeginning;
      });
      nextButtons.forEach(function (button) {
        button.disabled = swiper.isEnd;
      });
    }

    function bindSwiper() {
      var swiper = swiperEl.swiper;
      if (!swiper) return;

      updateArrows(swiper);
      setActive(selectedIndex);
      swiperEl.classList.add('swiper-initialized');
      root.classList.add('is-ready');

      swiper.on('slideChange', function () {
        updateArrows(swiper);
        if (!lockSelected) setActive(swiper.activeIndex);
      });

      swiper.on('slideChangeTransitionEnd', function () {
        updateArrows(swiper);
        if (lockSelected) {
          setActive(selectedIndex);
        }
      });

      swiper.on('reachBeginning reachEnd fromEdge', function () {
        updateArrows(swiper);
      });
    }

    function start() {
      if (!root.isConnected || swiperEl.swiper) return;

      Object.assign(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        breakpoints: {
          990: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 40
          }
        }
      });

      var ready = swiperEl.initialize();
      if (ready && typeof ready.then === 'function') {
        ready.then(bindSwiper);
      } else {
        bindSwiper();
      }
    }

    prevButtons.forEach(function (button) {
      button.addEventListener('click', onPrev);
    });
    nextButtons.forEach(function (button) {
      button.addEventListener('click', onNext);
    });
    markers.forEach(function (marker) {
      marker.addEventListener('click', onJump);
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', onJump);
    });
    slides.forEach(function (slide) {
      slide.addEventListener('click', onSlideClick);
    });

    root._ctrDestroy = function () {
      if (unlockTimer) clearTimeout(unlockTimer);
      prevButtons.forEach(function (button) {
        button.removeEventListener('click', onPrev);
      });
      nextButtons.forEach(function (button) {
        button.removeEventListener('click', onNext);
      });
      markers.forEach(function (marker) {
        marker.removeEventListener('click', onJump);
      });
      dots.forEach(function (dot) {
        dot.removeEventListener('click', onJump);
      });
      slides.forEach(function (slide) {
        slide.removeEventListener('click', onSlideClick);
      });
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
      delete root._ctrDestroy;
      root.dataset.ctrInit = 'false';
    };

    root.dataset.ctrInit = 'true';
    ensureSwiper().then(start);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches(ROOT)) {
      initSection(context);
    }
    context.querySelectorAll(ROOT).forEach(initSection);
  }

  if (!window.__ctrPcosReliefTimelineBound) {
    window.__ctrPcosReliefTimelineBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector(ROOT);
      if (root && typeof root._ctrDestroy === 'function') root._ctrDestroy();
    });

    document.addEventListener('shopify:section:select', function (event) {
      var root = event.target.querySelector(ROOT);
      if (!root) return;
      var swiperEl = root.querySelector('[data-ctr-swiper]');
      if (swiperEl && swiperEl.swiper) swiperEl.swiper.update();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest(ROOT);
      var slide = event.target.closest('swiper-slide');
      if (!root || !slide) return;
      var swiperEl = root.querySelector('[data-ctr-swiper]');
      if (!swiperEl || !swiperEl.swiper) return;
      var slides = swiperEl.querySelectorAll('swiper-slide');
      var index = Array.prototype.indexOf.call(slides, slide);
      if (index > -1) swiperEl.swiper.slideTo(index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }
})();
